/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/v1/signed_message": {
    post: operations["SignedMessageController_createSignedMessage"]
  }
  "/v1/token-bridge/transfer-prophets": {
    post: operations["TokenBridgeController_createTransferProphet"]
  }
  "/v1/token-bridge/transfer-portals": {
    post: operations["TokenBridgeController_createTransferPortal"]
  }
  "/v1/token-bridge/orders": {
    get: operations["TokenBridgeController_getTokenBridgeOrders"]
  }
}

export interface components {
  schemas: {
    CreateSignedMessageRequest: {
      txId: string
      toAddress: string
      signedMessage: string
    }
    TransferProphetCreateInfoEthereum: {
      bigint_source_token_count: string
      /** @enum {string} */
      source_network: "ethereum"
      /** @enum {string} */
      target_network: "stacks"
      /** @enum {string} */
      source_token: "usdc"
    }
    TransferProphetCreateInfoStacks: {
      bigint_source_token_count: string
      /** @enum {string} */
      source_network: "stacks"
      /** @enum {string} */
      target_network: "ethereum"
      /** @enum {string} */
      source_token: "xusd"
    }
    CreateTransferProphetsRequest: {
      info:
        | components["schemas"]["TransferProphetCreateInfoEthereum"]
        | components["schemas"]["TransferProphetCreateInfoStacks"]
    }
    CreateTransferProphetsResponse: {
      wrap_costed_milliseconds: number
      /** @enum {string} */
      wrap_fee_token: "usdc" | "xusd"
      bigint_wrap_fee_token_count: string
      bigint_target_token_count: string
    }
    TransferPortalsCreateInfoEthereum: {
      bigint_source_token_count: string
      /** @enum {string} */
      source_network: "ethereum"
      /** @enum {string} */
      target_network: "stacks"
      /** @enum {string} */
      source_token: "usdc"
    }
    TransferPortalsCreateInfoStacks: {
      bigint_source_token_count: string
      /** @enum {string} */
      source_network: "stacks"
      /** @enum {string} */
      target_network: "ethereum"
      /** @enum {string} */
      source_token: "xusd"
    }
    CreateTransferPortalsRequest: {
      info:
        | components["schemas"]["TransferPortalsCreateInfoEthereum"]
        | components["schemas"]["TransferPortalsCreateInfoStacks"]
    }
    CreateTransferPortalsResponse: {
      receive_address: string
    }
    TokenBridgeHistoryOrderTransferSegmentStatusInProgress: {
      /** @enum {string} */
      type: "pending"
      transaction_hash?: string
      explorer_url?: string
    }
    TokenBridgeHistoryOrderTransferSegmentStatusWarning: {
      /** @enum {string} */
      type: "failed"
      transaction_hash?: string
      explorer_url?: string
    }
    TokenBridgeHistoryOrderTransferSegmentStatusSuccess: {
      /** @enum {string} */
      type: "processed"
      transaction_hash: string
      explorer_url: string
    }
    TokenBridgeHistoryOrderTransferSegmentEthereum: {
      address: string
      address_explorer_url: string
      estimated_bigint_token_amount: string
      bigint_token_amount?: string
      /** @enum {string} */
      network: "ethereum"
      /** @enum {string} */
      token: "usdc"
    }
    TokenBridgeHistoryOrderTransferSegmentStacks: {
      address: string
      address_explorer_url: string
      estimated_bigint_token_amount: string
      bigint_token_amount?: string
      /** @enum {string} */
      network: "stacks"
      /** @enum {string} */
      token: "xusd"
    }
    TokenBridgeSignMissingOrderWithType: {
      order_number: string
      source:
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentEthereum"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStacks"]
      source_status:
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusInProgress"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusWarning"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusSuccess"]
      created_at: string
      /** @enum {string} */
      type: "sign_missing_order"
    }
    TokenBridgeHistoryOrderWrappingSegmentStatus: {
      /** @enum {string} */
      type: "pending" | "failed" | "processed"
    }
    TokenBridgeHistoricalOrderWithType: {
      order_number: string
      bigint_fee: string
      /** @enum {string} */
      fee_token: "usdc" | "xusd"
      source:
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentEthereum"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStacks"]
      destination:
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentEthereum"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStacks"]
      source_status:
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusInProgress"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusWarning"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusSuccess"]
      wrapping_status?: components["schemas"]["TokenBridgeHistoryOrderWrappingSegmentStatus"]
      destination_status?:
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusInProgress"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusWarning"]
        | components["schemas"]["TokenBridgeHistoryOrderTransferSegmentStatusSuccess"]
      created_at: string
      /** @enum {string} */
      type: "historical_order"
    }
    GetTokenBridgeOrdersResponse: {
      orders: (
        | components["schemas"]["TokenBridgeSignMissingOrderWithType"]
        | components["schemas"]["TokenBridgeHistoricalOrderWithType"]
      )[]
    }
  }
}

export interface operations {
  SignedMessageController_createSignedMessage: {
    parameters: {}
    responses: {
      201: unknown
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateSignedMessageRequest"]
      }
    }
  }
  TokenBridgeController_createTransferProphet: {
    parameters: {}
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["CreateTransferProphetsResponse"]
        }
      }
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateTransferProphetsRequest"]
      }
    }
  }
  TokenBridgeController_createTransferPortal: {
    parameters: {}
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["CreateTransferPortalsResponse"]
        }
      }
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateTransferPortalsRequest"]
      }
    }
  }
  TokenBridgeController_getTokenBridgeOrders: {
    parameters: {
      query: {
        address0: string
        address1: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetTokenBridgeOrdersResponse"]
        }
      }
    }
  }
}

export interface external {}

export namespace ApiPaths {
  export const SignedMessageController_createSignedMessage = {
    url: "/v1/signed_message" as const,
    method: "post" as const,
  }
  export const TokenBridgeController_createTransferProphet = {
    url: "/v1/token-bridge/transfer-prophets" as const,
    method: "post" as const,
  }
  export const TokenBridgeController_createTransferPortal = {
    url: "/v1/token-bridge/transfer-portals" as const,
    method: "post" as const,
  }
  export const TokenBridgeController_getTokenBridgeOrders = {
    url: "/v1/token-bridge/orders" as const,
    method: "get" as const,
  }
}
